import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import DataParser from "../../utlits/Dataparser";
import MeetingsServices from "../../Services/MeetingsServices";

// The organiser runs a meeting until they end it. If they come back to Planit (a new login, a closed
// tab) while one of their meetings is still in progress, this offers to take them back to it.
// Asked once per login: the key includes the login token, so a new login asks again.
const OpenMeetingReminder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [meeting, setMeeting] = useState(null);

  useEffect(() => {
    const modules = DataParser.AllowedCompanyModules() || [];
    const perms = DataParser.CompanyUserPermissions() || [];
    if (!modules.includes("Meetings") || !perms.includes("meetings-list")) return;
    const key = `planit_open_meeting_${String(DataParser.AuthToken() || "").slice(-16)}`;
    try {
      if (localStorage.getItem(key)) return;
      localStorage.setItem(key, "1");
    } catch (e) { /* storage unavailable: ask anyway */ }
    // only meetings the user takes part in (the list may show their team's or the company's too)
    MeetingsServices.getMeetings({ view: "in_progress", limit: 20, scope: "mine" })
      .then((res) => {
        const mine = (res?.data || []).find((m) => m.me && m.me.is_organiser);
        if (mine && !window.location.pathname.endsWith(`/meetings/${mine.id}`)) setMeeting(mine);
      })
      .catch(() => {});
  }, []);

  // open the popup once the meeting is known (same hidden-trigger pattern as the other popups)
  useEffect(() => {
    if (!meeting) return;
    if (location.pathname.endsWith(`/meetings/${meeting.id}`)) return;
    const trigger = document.getElementById("openMeetingReminderModal");
    if (trigger) trigger.click();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meeting]);

  const goBack = () => {
    const close = document.getElementById("closeMeetingReminderModal");
    if (close) close.click();
    navigate(`/${DataParser.CompanyIdentifierRole()}/meetings/${meeting.id}`);
  };

  // rendered on the page body (like the meeting popup), so the header's stacking does not hide it
  return ReactDOM.createPortal(
    <>
      <div id="openMeetingReminderModal" data-bs-toggle="modal" data-bs-target="#meetingReminderModal" style={{ display: "none" }} />
      <div id="meetingReminderModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
            <div className="modal-header border-0 pb-1">
              <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Meeting in Progress</h5>
              <button type="button" className="btn-close" id="closeMeetingReminderModal" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body pt-2 pb-2">
              <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>
                Your meeting <b>{meeting ? meeting.title : ""}</b> is still in progress.
              </p>
              <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                <i className="uil uil-exclamation-triangle me-1" />
                Please return to it and end it when it is over.
              </p>
            </div>
            <div className="modal-footer border-0 pt-1">
              <button type="button" className="btn btn-light waves-effect" data-bs-dismiss="modal" style={{ borderRadius: "5px", fontSize: "13px" }}>Later</button>
              <button type="button" className="btn btn-primary waves-effect waves-light" onClick={goBack} style={{ borderRadius: "5px", fontSize: "13px" }}>Return to Meeting</button>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default OpenMeetingReminder;
